import { useContext } from 'react'

import { DATE_FNS_LOCALE } from '@hhgtech/hhg-components/constants'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Calendar } from '@hhgtech/icons/other'
import { Box, BoxProps } from '@mantine/core'
import { format } from 'date-fns'
import dayjs from 'dayjs'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { ScheduleEventCard } from 'interfaces/types'

import useStyles from './index.styles'
import { ScheduleEventContext } from '../../../context'
import { EventCard } from '../../../eventCard'

type Props = {
  groupByMothList: {
    monthArr: string[]
    monthLength: number
    listing: { [key in string]: ScheduleEventCard[] }
  }
} & BoxProps

export const DesktopLayout = ({
  groupByMothList,
  styles,
  classNames,
  className,
}: Props) => {
  const { maskcot, wrapperProps } = useContext(ScheduleEventContext)
  const { locale } = useRouterExtend()
  const { classes, cx } = useStyles(undefined, {
    name: 'ScheduleEvent__EventList-GroupByStatus--Desktop',
    styles,
    classNames,
  })

  return (
    <Box className={cx(className, classes.root)}>
      <Box className={classes.desc}>
        <Box className={cx(classes.maskcot)}>
          <img src={maskcot} alt="maskcot" loading="lazy" />
        </Box>
        <Box className={classes.info}>
          <Text size="h2">{wrapperProps.title}</Text>
          <Text size="p3">{wrapperProps.description}</Text>
        </Box>
      </Box>
      <Box className={classes.body}>
        <Box className={classes.bodyInner}>
          {groupByMothList.monthArr.map((month) => {
            const listing = groupByMothList.listing[month] || []
            return (
              <Box key={month} className={cx(classes.group)}>
                <Box className={classes.header}>
                  <Box className={classes.headerLeft}>
                    <Box className={cx(classes.icon)}>
                      <Calendar size={24} color="currentColor" />
                    </Box>
                    <Text size="h2" as="h2" className={classes.heading}>
                      {format(
                        new Date(2020, dayjs(month, 'MM-YYYY').month(), 1),
                        'MMMM',
                        {
                          locale:
                            DATE_FNS_LOCALE[
                              locale as keyof typeof DATE_FNS_LOCALE
                            ],
                        },
                      )}
                    </Text>
                  </Box>
                </Box>
                <Box className={classes.listing}>
                  {listing.map((i, idx) => (
                    <Box className={cx(classes.cardWrapper)} key={idx}>
                      <EventCard item={i} className={cx(classes.card)} />
                    </Box>
                  ))}
                </Box>
              </Box>
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}
